module.exports = __webpack_public_path__ + "img/MTABAPPECG.fbf957e2.svg";